import { MediaType } from "@aichat/types/index";

export const detectFileType = async (url: string): Promise<MediaType> => {
  if (url.includes("youtube.com") || url.includes("youtu.be")) {
    return MediaType.YOUTUBE_VIDEO;
  } else if (url.match(/\.(jpeg|jpg|png|gif|webp|svg)$/i)) {
    return MediaType.IMAGE;
  } else if (url.match(/\.(mp4|webm|ogg|avi|mov|mkv)$/i)) {
    return MediaType.VIDEO;
  } else if (url.match(/\.(gif)$/i)) {
    return MediaType.GIF;
  } else {
    return await fetchUrl(url);
  }
};

const fetchUrl = async (blobUrl: string): Promise<MediaType> => {
  try {
    const response = await fetch(blobUrl);
    const contentType = response.headers.get("Content-Type");
    if (contentType?.startsWith("image/")) {
      return MediaType.IMAGE;
    } else if (contentType?.startsWith("video/")) {
      return MediaType.VIDEO;
    } else if (contentType === "image/gif") {
      return MediaType.GIF;
    } else {
      return MediaType.UNKNOWN;
    }
  } catch (error) {
    console.error("Error fetching url:", error);
    return MediaType.UNKNOWN;
  }
};

export const getYouTubeVideoId = (url: string): string | null | undefined => {
  const match = url.match(
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/ ]{11})/,
  );
  return match ? match[1] : null;
};

export const getMediaUrl = (props: {
  file: File | null;
  url: string;
  isLoading: boolean;
}) => {
  const { file, url, isLoading } = props;

  const defaultValue = {
    url: "",
    filename: "",
  };

  if (isLoading) return defaultValue;

  if (file)
    return {
      url: file ? URL.createObjectURL(file) : "",
      filename: file.name,
    };

  if (url)
    return {
      url,
      filename: url,
    };

  return defaultValue;
};

export const observeDOM = (type: "video" | "youtube" = "video") => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target as HTMLVideoElement | HTMLIFrameElement;

        if (type === "youtube") {
          if (!entry.isIntersecting) {
            pauseYoutube(video as HTMLIFrameElement);
          }
          return;
        }
        if (!entry.isIntersecting) {
          (video as HTMLVideoElement).pause();
        }
      });
    },
    {
      threshold: 0.5,
    },
  );
  return observer;
};

function pauseYoutube(iframe: HTMLIFrameElement) {
  iframe.contentWindow?.postMessage(
    '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
    "*",
  );
}
